import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faVimeo } from '@fortawesome/free-brands-svg-icons';
//import logo from '../assets/photography/logo-index.svg'

const Footer = () => {
  return (
    <footer className="bg-gray-300 text-black pt-6 pb-16 md:pb-6">
      <div className="container mx-auto flex flex-col items-center justify-center gap-2 px-4">
        <div className="flex items-center gap-2">
          {/* -- <img src={logo} alt="footer_logo" className="w-8 sm:w-9" /> */}
          <p className="text-xs sm:text-sm font-medium">Los Angeles, CA</p>
        </div>

        <p className="text-xs sm:text-sm font-medium text-center">
          © {new Date().getFullYear()} 
          {" · "}
          <a
            href="mailto:jasminelopezvieyra@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-lime-800"
          >
            Jasmine Lopez Vieyra
          </a>
        </p>

        <div className="flex items-center gap-3">
          <a href="https://www.instagram.com/jas.lo" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faInstagram} className="w-5 h-5 text-lime-950" />
          </a>
          <a href="https://vimeo.com/user215090412" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faVimeo} className="w-5 h-5 text-lime-950" />
          </a>
          <a href="mailto:jasminelopezvieyra@gmail.com" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faEnvelope} className="w-5 h-5 text-lime-950" />
          </a>
        </div>

        <p className="text-[11px] text-center text-black/60 mt-1">
          Created by{" "}
          <a
            href="https://almaalvarado.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-lime-800"
          >
            Alma Alvarado
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
